import React, { useEffect, useState } from 'react'
import { Modal } from 'react-bootstrap'
import SelectBox from 'devextreme-react/select-box';

const LogInSelectCompanyModal = ({ show, onHide, companies }) => {
    const [selectedCompany, setSelectedCompany] = useState(null)
    const [errorText, setErrorText] = useState(null)

    useEffect(() => {
        if (companies && companies.length > 0) {
            setSelectedCompany(companies[0])
        }
    }, [companies])

    const handleCompanyChange = (e) => {
        setErrorText(null)
        setSelectedCompany(e.value)
    }
    const handleSelectCompany = () => {
        if (!selectedCompany) {
            setErrorText('Proszę wybrać firmę')
            return
        }
        onHide(selectedCompany.custId)
    }
    return (
        <Modal size='lg' show={show} onHide={onHide} centered>
            <Modal.Header closeButton>
                <Modal.Title>Proszę wybrać firmę, na która chcesz sie zalogować</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <SelectBox
                    items={companies}
                    value={selectedCompany}
                    placeholder='Wybierz firmę'
                    noDataText='Brak danych'
                    displayExpr={(item) => item ? `"${item.name}", NIP: ${item.nip}` : ''}
                    onValueChanged={handleCompanyChange}
                />
                <div className="row text-center mt-3">
                    <span className='error-text-color'>{errorText}</span>
                </div>
                <div className="d-flex justify-content-end mt-4">
                    <button className='btn-app-primary me-3' onClick={handleSelectCompany}>Wybierz</button>
                    <button className='btn-app-secondary' onClick={onHide}>Anuluj</button>
                </div>
            </Modal.Body>
        </Modal>
    )
}

export default LogInSelectCompanyModal